import React from 'react'
import Modal from "./Modal";
import "./RightSide.css";
import jwt_decode from "jwt-decode";

      // console.log("shopname=>", shopname);
const LeftSide = () => {

  const code = sessionStorage.getItem("code");
      var decoded = jwt_decode(code);
  
      const shopname = decoded.jwttoken;
  return (
    <React.Fragment>
      <div className='col-lg-4 col-md-4 col-sm-4 side text-center'>
        <div>
          {/* `https://${shopname}/` */}
        <a href={`https://${shopname}/`} target="_blank" rel="noopener noreferrer" className='text-dec'>
        
          {/* <img className='eye-icon' src="asset/preview.png" alt=".." id='tooltip'/> */}

          <div id="tooltip"><img className='eye-icon' src="asset/preview.png" alt=".." id='tooltip'/>
  <span id="tooltiptext">Preview</span>
</div>

          
        </a>
        </div>
      <div>
        
      <img className={`side_img`} src="asset/icon.png" alt=".."/>
      </div>
      
      <h3 className='h3'>Welcome</h3>
      <p>Let's bring back lost customers</p>
      {/* <button type="button" className="btn btn-light rounded-pill px-5 my-2" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
        Help        
      </button> */}
      <React.Fragment>
        {/* <Modal/> */}
        </React.Fragment>
      <h3>By ENS Enterprises</h3>
      </div>
    </React.Fragment>
  )
}

export default LeftSide;
